import { render } from "./infobar_abo.vue?vue&type=template&id=6e460c4c"
import script from "./infobar_abo.vue?vue&type=script&lang=js"
export * from "./infobar_abo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ORM_CRENT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__